import React from "react";
import { BrowserRouter } from "react-router-dom";
import SiteRouter from "./siterouter";

export default function App() {
  return (
    <BrowserRouter>
      <SiteRouter />
    </BrowserRouter>
  );
}
